import React from "react";
import NodeTeamMemberTeaser from "components/TeamMember/NodeTeamMemberTeaser";

export default function NodeTeamMemberList({ nodes, isInViewport = true }) {
  const transitionDuration = 0.5;
  const transitionDelay = transitionDuration * 0.5;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
      {nodes.map((node, index) => {
        const thisTransitionDelay = transitionDelay * index;

        return (
          <div
            key={node.id}
            className="transition-all"
            style={{
              opacity: isInViewport ? 100 : 0,
              transform: `translateY(${isInViewport ? 0 : "-1.5rem"})`,
              transitionDuration: `${transitionDuration}s`,
              transitionDelay: `${thisTransitionDelay}s`,
            }}
          >
            <NodeTeamMemberTeaser node={node} />
          </div>
        );
      })}
    </div>
  );
}
